import { Button, Col, Form, message, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useSocket } from "@components/SocketProvider";
import planningService from "@services/planning.service";
import transmissionService from "@services/transmission.service";
import Chart from "./components/Chart";

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
};
/* eslint-enable no-template-curly-in-string */

const Dashboard = () => {
  const socket = useSocket();

  const [submitted, setSubmitted] = useState(false);
  const [data, setData] = useState([]);
  const [regions, setRegions] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [provinces, setProvinces] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [cities, setCities] = useState({
    loading: false,
    data: [],
    error: null,
  });

  const [form] = Form.useForm();

  async function fetchRegions() {
    setRegions({ ...regions, loading: true });

    try {
      const res = await transmissionService.fetchRegions();

      setRegions({
        ...regions,
        loading: false,
        data: res.data.map((r) => ({ label: r, value: r })),
      });
    } catch (error) {
      console.log(error);
      setRegions({ ...regions, loading: false, error: error });
    }
  }

  async function fetchProvinces() {
    setProvinces({ ...provinces, loading: true });
    try {
      const res = await planningService.fetchProvinces();
      setProvinces({
        ...provinces,
        loading: false,
        data: res.data.map((p) => ({ label: p, value: p })),
      });
    } catch (error) {
      console.log(error);
      setProvinces({ ...provinces, loading: false, error: error });
    }
  }

  async function fetchCities() {
    setCities({ ...cities, loading: true });

    try {
      const res = await planningService.fetchCities();
      setCities({
        ...cities,
        loading: false,
        data: res.data.map((c) => ({ label: c, value: c })),
      });
    } catch (error) {
      console.log(error);
      setCities({ ...cities, loading: false, error: error });
    }
  }

  function fetchDatas() {
    fetchProvinces();
    fetchRegions();
    fetchCities();
  }

  useEffect(() => {
    fetchDatas();

    // eslint-disable-next-line
  }, []);

  const onFinish = async (values) => {
    setSubmitted(true);
    try {
      const res = await transmissionService.viewDashboard({
        ...values,
        io_id: socket.id,
      });

      setData(res.data);
    } catch (err) {
      message.error("Action has error",20);
      console.log(err);
    } finally {
      setSubmitted(false);
    }
  };


  return (
    <div className="p-5">
      <div className="bg-white border border-gray-200 rounded-md p-5 flex-grow">
        <Form
          form={form}
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          validateMessages={validateMessages}
          // onValuesChange={handleFormValuesChange}
        >
          <Row gutter={[14, 0]}>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
              <Form.Item
                name="region"
                label="Region"
                rules={[
                  {
                    type: "array",
                    // required: true,
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  maxTagCount={5}
                  options={regions.data}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
              <Form.Item
                name="province"
                label="Province"
                rules={[
                  {
                    type: "array",
                    // required: true,
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  maxTagCount={5}
                  options={provinces.data}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
              <Form.Item
                name="city"
                label="City"
                rules={[
                  {
                    type: "array",
                    // required: true,
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  maxTagCount={5}
                  options={cities.data}
                />
              </Form.Item>
            </Col>

            <Col flex="auto" className="flex justify-end items-end">
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={submitted}
                  className="mt-4"
                >
                  View
                </Button>
                <Button
                  style={{ margin: "0 8px" }}
                  onClick={() => {
                    form.resetFields();
                  }}
                >
                  Clear
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-white rounded-md border border-gray-200 p-5">
          <Chart data={[...data]} loading={submitted}/>
        </div>
        <div className="bg-white rounded-md border border-gray-200 p-5">
          <Chart data={[...data]} loading={submitted} />
        </div>
        <div className="bg-white rounded-md border border-gray-200 p-5">
          <Chart data={[...data]} loading={submitted} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
